import { trustInfo } from '@/mocks/contactData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function TrustBar() {
  return (
    <section className="relative bg-brand-deep py-12 md:py-16 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.08]">
        <img
          src={readdy('trust-bar-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">

          <ScrollReveal variant="fade-up">
            <div className="text-center mb-10">
              <p className="text-brand-gold/50 text-sm tracking-widest mb-3 font-medium">品牌承诺</p>
              <h3 className="text-xl md:text-2xl font-bold text-white">
                十余年专注，为每一份信任负责
              </h3>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {trustInfo.map((item, i) => (
              <ScrollReveal key={item.title} variant="fade-up" delay={i * 100}>
                <div className="text-center bg-white/5 rounded-2xl p-5 md:p-6 border border-white/8">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-brand-gold/15 text-brand-gold">
                    <i className={`${item.icon} text-xl`} />
                  </div>
                  <h4 className="text-sm font-semibold text-white mb-1">{item.title}</h4>
                  <p className="text-white/40 text-xs">{item.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <div className="mt-10 text-center">
            <p className="text-white/30 text-xs">
              {new Date().getFullYear()} 麦杰集团 — 专业减肥纤体连锁品牌
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}